import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-link-click-modal',
    templateUrl: './link-click-modal.component.html',
    styleUrls: ['./link-click-modal.component.scss'],
    standalone: false
})
export class LinkClickModalComponent implements OnInit {

  @Input() isModalActive: boolean = true;
  @Output() closed = new EventEmitter();

  constructor() { }

  ngOnInit() { }

  cancel() {
    this.closed.emit(null);
    this.isModalActive = !this.isModalActive;
  }
}
